"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlitzLogoType = exports.BlitzLogoConfig = exports.BlitzLogo = void 0;
var _pixi = require("pixi.js");
var _gsap = _interopRequireDefault(require("gsap"));
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
var _runtime = require("@pixi-spine/runtime-3.8");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BlitzLogoType = exports.BlitzLogoType = /*#__PURE__*/function (BlitzLogoType) {
  BlitzLogoType[BlitzLogoType["Sprite"] = 0] = "Sprite";
  BlitzLogoType[BlitzLogoType["Spine"] = 1] = "Spine";
  BlitzLogoType[BlitzLogoType["None"] = 2] = "None";
  return BlitzLogoType;
}({});
var BlitzLogoConfig = exports.BlitzLogoConfig = /*#__PURE__*/_createClass(function BlitzLogoConfig() {
  _classCallCheck(this, BlitzLogoConfig);
  _defineProperty(this, "type", void 0);
  _defineProperty(this, "name", void 0);
  _defineProperty(this, "win", void 0);
  _defineProperty(this, "intro", void 0);
  _defineProperty(this, "scale", void 0);
  _defineProperty(this, "mYOffset", void 0);
  _defineProperty(this, "mXOffset", void 0);
  _defineProperty(this, "skin", void 0);
});
var BlitzLogo = exports.BlitzLogo = /*#__PURE__*/function (_CustomPixiContainer) {
  function BlitzLogo(parent, logoConfig) {
    var _this;
    _classCallCheck(this, BlitzLogo);
    _this = _callSuper(this, BlitzLogo);
    _defineProperty(_this, "_showing", false);
    _defineProperty(_this, "_logoDisplayObject", void 0);
    _defineProperty(_this, "blitzSprite", void 0);
    _defineProperty(_this, "_blitzLogoConfig", void 0);
    _defineProperty(_this, "handleResize", function (c) {
      _this.scale.set(1);
      _this.visible = true;
      if (c.channel == _core.Channel.Mobile) {
        switch (c.orientation) {
          case _core.Orientation.Portrait:
            {
              var scale = (c.width - 10) / _this.width;
              if (scale > 0.8) scale = 0.8;
              if (c.width >= 768) {
                // ipad
                scale = 1.2;
              }
              _this.scale.set(scale);
              _this.y = 64 * scale;
              if (_this._blitzLogoConfig.mYOffset) _this.y += _this._blitzLogoConfig.mYOffset;
              if (_this._blitzLogoConfig.mXOffset) _this.x += _this._blitzLogoConfig.mXOffset;
              _this.x = c.width / 2 - _this.blitzSprite.width * scale / 2;
              break;
            }
          default:
            {
              _this.visible = false;
            }
        }
      } else {
        _this.scale.set(c.scaleFactor);
        _this.y = _this._logoDisplayObject.height / 2 + 10 > 50 ? (_this._logoDisplayObject.height / 2 + 10) * c.scaleFactor : 56 * c.scaleFactor;
        if (_this._blitzLogoConfig.mYOffset) _this.y += _this._blitzLogoConfig.mYOffset;
        _this.x = c.width / 2;
        if (_this._blitzLogoConfig.mXOffset) _this.x += _this._blitzLogoConfig.mXOffset;
      }
    });
    _defineProperty(_this, "play", function () {
      if (_this._blitzLogoConfig.type === BlitzLogoType.Spine) {
        _this._logoDisplayObject.state.timeScale = 1;
        _this._logoDisplayObject.state.setAnimation(0, _this._blitzLogoConfig.win, false);
      }
    });
    _defineProperty(_this, "hide", function () {
      if (_this._showing) {
        _gsap["default"].killTweensOf(_this);
        _gsap["default"].to(_this, {
          alpha: 0,
          duration: 0.5
        });
        _this._showing = false;
      }
    });
    _defineProperty(_this, "show", function () {
      if (!_this._showing) {
        _this.play();
        _gsap["default"].killTweensOf(_this);
        _this._showing = true;
        _gsap["default"].to(_this, {
          alpha: 1,
          duration: 1
        });
      }
    });
    _this._blitzLogoConfig = logoConfig;
    var res = _core.CORE.loader.resources;
    switch (_this._blitzLogoConfig.type) {
      case BlitzLogoType.Spine:
        {
          _this._logoDisplayObject = new _runtime.Spine(res[logoConfig.name].spineData);
          if (_this._blitzLogoConfig.skin) _this._logoDisplayObject.skeleton.setSkinByName(_this._blitzLogoConfig.skin);

          //    this._logoDisplayObject.state.timeScale = 1000;
          _this._logoDisplayObject.state.setAnimation(0, logoConfig.intro, true);
          _this._logoDisplayObject.scale.set(logoConfig.scale ? logoConfig.scale : 1);
          break;
        }
      default:
        {
          _this._logoDisplayObject = new _pixi.Sprite(_pixi.Texture.from(logoConfig.name));
          _this._logoDisplayObject.anchor.set(0.5);
        }
    }
    _this.blitzSprite = new _pixi.Sprite(_pixi.Texture.from("blitz_logo.png"));
    _this.blitzSprite.anchor.set(0, 0.5);
    _this.blitzSprite.x = _this._logoDisplayObject.width / 2;
    _this.addChild(_this._logoDisplayObject, _this.blitzSprite);
    parent.addChild(_this);
    _core.CORE.subscribe("config.screenSize", _this.handleResize);
    return _this;
  }
  _inherits(BlitzLogo, _CustomPixiContainer);
  return _createClass(BlitzLogo);
}(_pixiGame.CustomPixiContainer);
//# sourceMappingURL=BlitzLogo.js.map